export default __webpack_public_path__ + "static/media/19thAnnualLecture.66183ef4.png";